// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import React, { useState } from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons, MaterialCommunityIcons } from '@expo/vector-icons';
import colors from '../../../../../../config/colors';
import DataPickerStyle from '../../../../../../styles/Farmer/DataPickerStyle';
const DatePickerLabel = ({ type, subtype, quantity, date }) => {
  const [buttonTitle] = useState(date);
  const [material, setMaterial] = useState(subtype);
  const [inputQuantity, setInputQuantity] = useState(quantity);

  return (
    <View>
      <TouchableOpacity
        style={[
          DataPickerStyle.button,
          {
            backgroundColor:colors.white, 
          },
        ]}
      >
        {type === 'event' ? (
          <>
            <MaterialIcons name="event" size={24} color={colors.green} />
            <Text style={DataPickerStyle.buttonText}>{buttonTitle}</Text>
          </>
        ) : type === 'quantity' ? (
          <>
            <Text style={DataPickerStyle.buttonText}>{inputQuantity}</Text>
          </>
        ) : (
          <>
            <Text style={DataPickerStyle.buttonText}>{material}</Text>
          </>
        )}
      </TouchableOpacity>
    </View>
  );
};

export default DatePickerLabel;
